module.exports = __webpack_public_path__ + "img/logo-arenabet.738711f9.svg";